import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFWmsEntities } from '@pf/shared-common';
import { PutAwayRead } from '../../entities/put-away.dto';

@Injectable()
export class PutAwayStore extends AbstractEntityStore<PutAwayRead> {
    constructor() {
        super(PFWmsEntities.PutAway);
    }
}
